/**
 * Build-time configuration. Only `VITE_*` variables are exposed to the bundle,
 * so never put secrets here: everything in this object is public.
 */
function readApiBaseUrl(): string {
  const value = import.meta.env.VITE_API_BASE_URL ?? '/api';
  if (!/^(\/|https?:\/\/)/.test(value)) {
    throw new Error(`VITE_API_BASE_URL must be a path or http(s) URL, got "${value}"`);
  }
  return value.replace(/\/+$/, '');
}

export const env = {
  apiBaseUrl: readApiBaseUrl(),
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
} as const;
